import { gql } from 'src/__generated__'

export default gql(`
  mutation rejectFoodConflict($data: RejectFoodConflictInput!) {
    rejectFoodConflict(data: $data)
  }
`)
